/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Inject, Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {NavigationConfig} from '../models/navigation-config';

@Injectable({
    providedIn: 'root'
  }
)
export class NavigationService {

  navigationConfigs: NavigationConfig[] = [];

  constructor(private router: Router,
              @Inject('navigation-config') private config: NavigationConfig[][]) {
    setTimeout(()=>{
      this.initNavigationConfigs();

    }, 1000)
  }

  initNavigationConfigs() {
    this.config.forEach(item => {
      this.navigationConfigs.push(...item);
    });
  }

  navigateByKeyV2(key: any, param?: any) {
    if(param && Object.entries(param).length !== 0 && (typeof NavigationService.notificationHrefState[key] === 'function')) {
      this.navigate(NavigationService.notificationHrefState[key](param));
    }
    else {
      this.navigate(NavigationService.notificationHrefState[key]);
    }
  }

  private navigate(navigationUrl: any){
    if(navigationUrl instanceof Array){
      this.router.navigate(navigationUrl)
    }else{
      this.router.navigateByUrl(navigationUrl)
    }
  }

  navigateByKey(key: any, param?: any) {

    const params = {...param}; // shallow copy

    const pathObject = this.navigationConfigs.filter(item => {
      return item.key === key;
    })[0];

    if (pathObject) {
      let basePath;

      if (pathObject.linkBuilder) {
        basePath = pathObject.linkBuilder(params);
        this.router.navigateByUrl(basePath);
      } else {
        basePath = this.buildBasePath(pathObject, params, (item: any) => {
          delete params[item];
        });
        this.router.navigate([basePath], {
          queryParams: params
        });
      }

    }
  }

  private buildBasePath(pathObject: any, params: any, callback: any): string {
    return pathObject.link.split(/[{}]/).map((item: any, index: any) => {
      if (index % 2 === 1) {
        let newItem = item;
        if (params[item]) {
          newItem = params[item];
          callback(item);
        }
        return newItem;
      }
      return item;
    }).join('');
  }

  static hrefState = {};

  static setHrefState(hrefConfig: any) {
    NavigationService.hrefState = {...this.hrefState, ...hrefConfig};
  }

  static notificationHrefState = {};

  static setNotificationHrefState(hrefConfig: any) {
    NavigationService.notificationHrefState = {...this.notificationHrefState, ...hrefConfig};
  }
}
